import { render } from "./requests-table.template.html?vue&type=template&id=2c37fccd&scoped=true"
import script from "./RequestsTable.vue?vue&type=script&lang=ts"
export * from "./RequestsTable.vue?vue&type=script&lang=ts"

import "./RequestsTable.vue?vue&type=style&index=0&id=2c37fccd&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2c37fccd"

export default script